import { OldEditEvaluation } from 'models/oldEvaluation.model'

export const defaultValues: OldEditEvaluation = {
  details: {
    name: '',
    description: '',
  },
  config: {
    approvalPoints: 0,
    maxRetries: 3,
    showResults: true,
    randomQuestions: true,
    editedQuestions: [],
  },
}

export enum EvaluationSteps {
  DETAILS = 0,
  QUESTIONS = 1,
  CONFIG = 2,
}

export enum ModalTypes {
  CONFIRMATION = 'confirmation',
  OPTIONS = 'options',
}
